module.exports = __webpack_public_path__ + "static/supercast-logo-5261b7f1034f92d43eb330777038630c.svg";